export default {"src":"/_next/static/media/our-partners-img-two.bd865c1e.svg","height":128,"width":150};